module.exports = __webpack_public_path__ + "static/media/laser.197c9f31.svg";